import React from "react";
import { Card, Page, Icon } from "@shopify/polaris";
import { ChartVerticalFilledIcon } from "@shopify/polaris-icons";

export function SalesTrendsTableImportingSkeleton(): React.JSX.Element {
  return (
    <Page>
      <Card>
        <div className="Polaris-IndexTable__EmptySearchResultWrapper">
          <div className="Polaris-LegacyStack Polaris-LegacyStack--vertical Polaris-LegacyStack--alignmentCenter">
            <div className="Polaris-LegacyStack__Item">
              <Icon source={ChartVerticalFilledIcon} />
            </div>
            <div className="Polaris-LegacyStack__Item">
              <p className="Polaris-Text--root Polaris-Text--headingLg">No trends yet</p>
            </div>
            <div className="Polaris-LegacyStack__Item">
              <span className="Polaris-Text--root Polaris-Text--subdued">
                <p>Please wait while we finish importing your store</p>
              </span>
            </div>
          </div>
        </div>
      </Card>
    </Page>
  );
}
